import React from 'react';
import map from 'lodash/map';
import styled from 'styled-components';

import inlineContainer from '@ad-scripts/presentation/components/common/containers/inline_container';

type FieldType = string | JSX.Element | null;
type KeyValueReadOnlyFieldsType = { fields: Record<string, FieldType> };

const KeyValueReadOnlyFields = ({ fields }: KeyValueReadOnlyFieldsType) => {
  const fieldList = map(fields, (field: Record<string, FieldType>, key: string) => {
    return (
      <StyledRow key={key}>
        <DetailsLabel className="details-label">{key}</DetailsLabel>
        <DetailsValue data-aid={key}>{field}</DetailsValue>
      </StyledRow>
    );
  });

  return <>{fieldList}</>;
};

const StyledRow = styled(inlineContainer).attrs({ stack: 'none', inset: 'small' })``;

const DetailsLabel = styled.div`
  width: 120px;
`;

const DetailsValue = styled.div`
  display: block;
  flex: 1;
  font-weight: bold;
`;

export default KeyValueReadOnlyFields;
